<template>
  <transition name="slide">
    <div class='page column flex'>
      <app-header title="提交成功" class="flex0">
        <i slot="back" v-if="history.length>1"></i>
      </app-header>
      <div class="flex1">
        <div class="weui-msg">
          <div class="weui-msg__icon-area"><i class="weui-icon-success weui-icon_msg"></i></div>
          <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">提交成功</h2>
            <p class="weui-msg__desc">您的{{ consultTypeText }}已经提交，我们会尽快回答您的问题</p>
          </div>
          <div class="weui-msg__opr-area">
            <p class="weui-btn-area">
              <van-count-down v-if="djsIsEnd===false" :time="time" @finish="finish" format="ss秒后可以可查看申请记录"/>
              <van-button v-if="djsIsEnd" @click="goDoctorList()" type="info" round block>查看申请记录</van-button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import {history} from "../../lib/class";
import header from '../../base/header'
import {consultService} from "@/services/consult";
import {consultMixin} from "@/lib/mixins/consult";
import {CONSULT_TYPE} from "@/lib/config";

export default {
  mixins: [consultMixin],
  data() {
    return {
      history: new history().get(),
      consultId: "",
      title: "提交成功",
      rightTitle: "",
      info: {},
      time: 5 * 1000 + (5 * Math.random() * 1000),
      djsIsEnd: false
    }
  },
  computed: {
    consult() {
      return this.info.consult || {}
    },
    consultTypeText() {
      return CONSULT_TYPE[this.consultType] || "";
    }
  },
  methods: {
    finish() {
      this.djsIsEnd = true;
    },
    goDoctorList() {
      this.$router.replace({
        path: '/team/consult/' + this.consultId,
      })
    },
    async getDetail() {
      this.info = await consultService.detail(this.consultId);
    }
  },
  mounted() {
    this.consultId = this.$route.query.consultId
    this.getDetail()
  },

  components: {
    "VHeader": header
  }
}

</script>
<style scoped lang="scss">
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s;
}

.slide-enter, .slide-leave-to {
  transform: translate3d(100%, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/index/allConsultSuccess.vue